export const initialState = {
  healthConditionGroups: []
};
